module.exports = __webpack_public_path__ + "static/media/inside_front_picture.d911a6db.png";